import { API_URL, ASSETS_URL } from "../../constants/config";
import $ from "jquery";
import moment from 'moment';
import timezone from 'moment-timezone';
import jstz from 'jstz';
import { getCache } from "../../components/Page/utils/cacheManager";
import { getAllCourses } from "../../api/initialApis"; 

let dateFormatServer = 'd-m-y';
let selected_timezone_txt = '';
let __free_label_enabled = 1;
let __free_label = 'FREEs';
let __free_button_enabled = 1;
let __free_button = 'ENROLL NO';
let __buy_now_button_enabled = 1;
let __buy_now_button = 'BUY NOW';
let _show_member_price = '0';
let _member_pricing_label = 'Member';
let _current_pricing_label = 'Current Price';
let _buy_now_label = 'BUY NOW';
let _event_buy_now_label = 'Buy Now';
let _buy_now_show = '1';
let _free_course_label = 'FREEs';
let _free_event_label = 'Free';
let _free_course_show = '1';
let _free_course_btn_label = 'ENROLL NO';
let _enquiry_button_show = '1';
let _enquiry_button_label = 'Enquiry Now';
let _free_event_btn = 'Enroll Now';
let _free_course_btn_show = '1';
let isCartEnabled = '1';
let isGuestEnabled = '1';
let isBfoEnabled = '1';
let learnerConsent = '1';
let redirectTypeFree = 'my_subscription';
let redirectUrlFree = '/student-dashboard/courses';
let organisationOnPurchase = '1';
let __headerBgColor = '#00af1c';
let btn_text = '';
let __siteUrl = ''; 
let siteUrl = ''; 
let __site_url = '';
let __timeZones = '';
let __timezone = '';
let __course_filter = 0;
let current_currency  = '';
let __default_course_path = '';
let __blended_course_path  = '';
let site_url          = '';
let __configuredTimeZone = '';
let isLoggedin           = false;
let __default_catalog_path = '';
let __catalog_path   = '';
let __course_path  = '';
let __current_acct_domain = '';
let __admin_name   = '';
let __four_column  = 1;
let __isBmsFeature  = '1';
let assets_url      = '';
let loggedUserid = '';
let __memcacheKey = '';
let isBulkPurchase = true;

function cleanFilePath(url) {
    return url.substr(url.indexOf('uploads'));
}

function getFullPath(path = "", type = "") {
    let default_path = '';
    let upload_path = ''; 
    // return default_path; //switch(type) { case 'course': default_path = 'https://d2cl07xv2ii8xi.cloudfront.net/uploads/default/course/' + "default.jpg"; console.log(default_path); upload_path = 'uploads/saasdev.uk.mykademy.com/items_org/course/'; break; case 'bundle': default_path = 'https://d2cl07xv2ii8xi.cloudfront.net/uploads/default/catalog/' + "default.jpg"; upload_path = 'uploads/saasdev.uk.mykademy.com/items_org/catalog/'; break; case 'event': default_path = 'https://d2cl07xv2ii8xi.cloudfront.net/uploads/default/course/' + "default-events.jpg"; upload_path = 'uploads/saasdev.uk.mykademy.com/items_org/blended_course/website/'; break; case 'section': default_path = 'https://d2cl07xv2ii8xi.cloudfront.net/uploads/default/course/' + "default-section.jpg"; upload_path = 'uploads/saasdev.uk.mykademy.com/items_org/course/section/'; break; case 'lecture': default_path = 'https://d2cl07xv2ii8xi.cloudfront.net/uploads/default/course/' + "default-lecture.jpg"; upload_path = 'uploads/saasdev.uk.mykademy.com/items_org/course/lecture/'; break; case 'live': default_path = 'https://d2cl07xv2ii8xi.cloudfront.net/uploads/default/course/' + "default-live-lecture.jpg"; upload_path = 'uploads/saasdev.uk.mykademy.com/items_org/livefiles/'; break; case 'user': $default_path = 'https://d2cl07xv2ii8xi.cloudfront.net/uploads/default/user/' + "default.jpg"; $upload_path = 'uploads/saasdev.uk.mykademy.com/items_org/user/'; break; default: break; } if(path == "" || ["default.jpg", "default-section.jpg", "default-live-lecture.jpg", "default-events.jpg", "default-lecture.jpg"].includes(path)) { return default_path; } regex = /uploads/; if(regex.test(path)) { return 'https://d2cl07xv2ii8xi.cloudfront.net/' + cleanFilePath(path); } return 'https://d2cl07xv2ii8xi.cloudfront.net/' + upload_path + path; 
} 

let script = document.createElement('script');
script.src = API_URL +'assets/pseudo_files/custom_page_script.js';
script.async = true;
// script.onload = () => {loadTimeZones()};
document.body.appendChild(script);

export const filterCourses = (filter, enrolledCourses) => { 
        // console.log("filterCourses", filter);
        $('.nav-link').removeClass('active');
        $(document.querySelector(`#filterCourses_${filter}`)).addClass('active');
        __course_filter         = filter;
        applyFilter(document.querySelector(`#filterCourses_${filter}`), enrolledCourses);
      }

export const selectTimezone = (el, enrolledCourses) => {
        var value = el.value;
        var text = el.options[el.selectedIndex].text;
        __timezone          = value;       
       if(__timezone === "") {
        localStorage.removeItem("selected_timezone");
        localStorage.removeItem("selected_timezone_txt");
       }
       localStorage.selected_timezone = __timezone;
       localStorage.selected_timezone_txt = text;
        setTimeout(function(){
            applyFilter(el, enrolledCourses);
        },300);
    }
 
let __getCountries            =   [];
let afterLoginCallBack = null;
let ppsData            = {};
let ppsSkip            = false;


var date = new Date();
var month = date.getMonth()+1;
var day = date.getDate();
var _current_date = date.getFullYear() + '-' +
(month<10 ? '0' : '') + month + '-' +
(day<10 ? '0' : '') + day; 


// $("#select_time_zone").change(function() {
//     var thisObj         = $(this);
//     var timeZone        = $(this).val();
//     __timezone          = timeZone;
//     selected_timezone_txt = $("#select_time_zone option:selected").text();        
//    if(__timezone === "") {
//     localStorage.removeItem("selected_timezone");
//     localStorage.removeItem("selected_timezone_txt");
//     //sel_timezone = "";
//    }
//    localStorage.selected_timezone = __timezone;
//    localStorage.selected_timezone_txt = selected_timezone_txt;
//     setTimeout(function(){
//         applyFilter(thisObj);
//     },300);
// });
export const applyFilter = async (e, enrolledCourses) => {
    if (__timezone == '') {  
           var pre_selected_timezone = $('#select_time_zone').val();               
          if (typeof(localStorage.selected_timezone) !== "undefined" && localStorage.selected_timezone !== 'null') {   
            if (localStorage.selected_timezone != '') {
              pre_selected_timezone = localStorage.selected_timezone;
              $("#select_time_zone > option").each(function() {                  
                //   $(this).prop('selected', this.text.indexOf(localStorage.selected_timezone_txt) !== -1);  
                    $(this).prop('selected', this.value.indexOf(localStorage.selected_timezone) !== -1);
                });
            }
        }        
        __timezone = pre_selected_timezone;
      }
        const allCourses = await getCache("all_courses", getAllCourses, {}, 2592000);   
        const courses = excludeSubscribedCourses(allCourses, enrolledCourses);
     
        
        var coursesHtml = '';
        // console.log(courses, 'courses')
        if(courses.length > 0 ) {
            var n = 0; 
            $.each(courses,function(courseKey,course){ 
                if(__course_filter === 1 && (course['item_type'] === 'blended_course' || course['item_course_type'] === 'blended'))
                {
                    n = n+1;
                    coursesHtml     += __courseCardNew(course);
                }
                if(__course_filter === 2 && (course['item_type'] === 'blended_course' || course['item_type'] ===  'blended' || course['item_type'] === 'offline'))
                // if(__course_filter === 2 &&  course['item_type'] === 'offline')
                {
                    // console.log(n);
                    n = n+1;
                    coursesHtml     += __courseCardNew(course);
                }
                if(__course_filter === 3 && course['item_type'] === 'booking_event')
                {
                    n = n+1;
                    coursesHtml     += __courseCardNew(course);
                }
                if(__course_filter === 0)
                {
                    n = n+1;
                    coursesHtml     += __courseCardNew(course);
                } 
                if(__course_filter === 4 && (course['item_type'] === 'blended_course' || course['item_type'] ===  'blended') && course['item_type'] === 'online')
                {
                    n = n+1;
                    coursesHtml     += __courseCardNew(course);
                }
                if(__course_filter === 4 && course['item_type'] === 'bundle')
                {
                    n = n+1;
                    coursesHtml     += __courseCardNew(course);
                }
                if(__course_filter === 4 && (course['item_type'] === 'course' || course['item_type'] === 'online'))
                { 
                    n = n+1;
                    coursesHtml     += __courseCardNew(course);
                }
                if(__course_filter === 5 && course['item_type'] === 'bundle' && course['c_bundle_type'] == 1) {
                    n = n+1;
                    coursesHtml     += __courseCardNew(course);
                }
                if(n === 8){ return false;}
            });
            if(n === 0) {
                coursesHtml += '<div class="no-top-courses-wrapper">';
                coursesHtml += '<p>We are currently creating new courses to be launched soon.</p>';
                coursesHtml += '</div>'; 
            }
            //if(__course_filter === 0 && Object.keys(courses).length > 8) { 
                if(n > 8)
                {
                coursesHtml += '<div class="btn-center-div" id="load_more_courses_list">';
                coursesHtml += '<a href="'+window.__site_url+'course/listing?&course_filter='+__course_filter+'" class="btn btn-outline btn-md">View All</a>';
                coursesHtml += '</div>';
                }
        } else {
            coursesHtml += '<div class="no-top-courses-wrapper">';
            coursesHtml += '<p>We are currently creating new courses to be launched soon.</p>';
            coursesHtml += '</div>';
        }
        // document.querySelector('.custom-course-container #course_list_wrapper .row').innerHTML=coursesHtml;
        $(e).parents('.custom-course-container').find('#course_list_wrapper .row').html(coursesHtml);
        $(e).parents('.custom-course-container').find('.custom-block-wrapper-removable-child #load_more_courses_list').attr('style','display:none !important');
        $(e).parents('.custom-course-container').find('.custom-block-wrapper-removable-child #course_list_wrapper #load_more_courses_list').attr('style','display:block !important');
}

export const applyTimeZoneFilter = () => {
    if (__timezone === '') {  
        var pre_selected_timezone = $('#select_time_zone').val();               
       if (typeof(localStorage.selected_timezone) !== "undefined" && localStorage.selected_timezone !== 'null') {   
         if (localStorage.selected_timezone !== '') {
           pre_selected_timezone = localStorage.selected_timezone;
           $("#select_time_zone > option").each(function() {                  
            //    $(this).prop('selected', this.text.indexOf(localStorage.selected_timezone_txt) !== -1); 
                $(this).prop('selected', this.value.indexOf(localStorage.selected_timezone) !== -1); 
             });
         }
             
     }        
     __timezone = pre_selected_timezone;
   }
}

export const renderCustomCourseCard = async (enrolledCourses, shoppingCartEnabled) =>
 {
    // console.log('do ity');

    const allCourses = await getCache("all_courses", getAllCourses, {}, 2592000);   
    
    const courses = excludeSubscribedCourses(allCourses, enrolledCourses);

    var coursesHtml           = '';
    if(courses.length > 0 ) { 
        
        var blendedCourse       = [];
        var onlineCourse        = [];
        var offlineCourse       = [];
        var upcomingCourse      = [];
        var bundle              = [];
        var filtersHtml         = ``;   
        $.grep(courses, function(e) { 
            if(e["item_type"] !== undefined && e["item_type"].indexOf('blended') > -1){
                blendedCourse.push(e["item_type"].indexOf('blended'));
            }
            if(e["item_type"] !== undefined && e["item_type"].indexOf('offline') > -1){
                offlineCourse.push(e["item_type"].indexOf('offline'));
            }
            if(e["item_type"] !== undefined && e["item_type"].indexOf('booking_event') > -1){
                upcomingCourse.push(e["item_type"].indexOf('booking_event'));
            }
            if(e["item_type"] !== undefined && e["item_type"].indexOf('course') > -1){
                onlineCourse.push(e["item_type"].indexOf('course'));
            }
            if(e["item_type"] !== undefined && e["item_type"].indexOf('bundle') > -1){
                onlineCourse.push(e["item_type"].indexOf('bundle'));
                bundle.push(e["item_type"].indexOf('bundle'));
            }
            if(e["item_type"] !== undefined && e["item_type"].indexOf('online') > -1){
                onlineCourse.push(e["item_type"].indexOf('online'));
            }
        });
 
        if(blendedCourse.length !== 0 || offlineCourse.length !== 0 || onlineCourse.length !== 0 ){
            filtersHtml += `<div class="nav-item" style="display: block;"><a tab="0" role="tab" data-rr-ui-event-key="course_filter_0" id="filterCourses_0" aria-controls="allcourses-tabs-tabpane-course_filter_0" aria-selected="true" class="nav-link active" tabindex="0" href="javascript:void(0)">All Courses</a></div>`;

        }
        if(blendedCourse.length !== 0){
            filtersHtml +=`<div class="nav-item" style="display: block;"><a tab="1" role="tab" data-rr-ui-event-key="course_filter_1" id="filterCourses_1" aria-controls="allcourses-tabs-tabpane-course_filter_1" aria-selected="false" tabindex="-1" class="nav-link" href="javascript:void(0)">Blended</a></div>`;
        }
        if(onlineCourse.length !== 0){ 
            filtersHtml += `<div class="nav-item" style="display: block;"><a tab="4" role="tab" data-rr-ui-event-key="course_filter_4" id="filterCourses_4" aria-controls="allcourses-tabs-tabpane-course_filter_4" aria-selected="false" tabindex="-1" class="nav-link" href="javascript:void(0)">Online</a></div>`;
        }
        if(offlineCourse.length !== 0){
            filtersHtml += `<div class="nav-item" style="display: block;"><a tab="2" role="tab" data-rr-ui-event-key="course_filter_2" id="filterCourses_2" aria-controls="allcourses-tabs-tabpane-course_filter_2" aria-selected="false" tabindex="-1" class="nav-link" href="javascript:void(0)">Offline</a></div>`;
        }
        if(upcomingCourse.length !== 0){
            filtersHtml += `<div class="nav-item" style="display: block;"><a tab="3" role="tab" data-rr-ui-event-key="course_filter_3" id="filterCourses_3" aria-controls="allcourses-tabs-tabpane-course_filter_3" aria-selected="false" tabindex="-1" class="nav-link" href="javascript:void(0)">Upcoming</a></div>`;
        }
        if(bundle.length !== 0){
            filtersHtml += `<div class="nav-item" style="display: block;"><a tab="5" role="tab" data-rr-ui-event-key="course_filter_5" id="filterCourses_5" aria-controls="allcourses-tabs-tabpane-course_filter_5" aria-selected="false" tabindex="-1" class="nav-link link-hot-offer" href="javascript:void(0)">${window.__package_discount_title}</a></div>`;
        }
        coursesHtml         += `
        <div class="row">
        <div class="col-lg-8 course-order-2">
            <div class="courses-navbar">
            <div class="pt-2 nav nav-pills" role="tablist">
                ${filtersHtml}
            </div>
            </div>
        </div>
    </div>`;
    coursesHtml +=`
            <div id="course_list_wrapper" class="tab-content">
                <div class="fade tab-pane active show">
                    <div class="p-3">
                        <div class="row">`;
        var n = 0; 
        $.each(courses,function(courseKey,course){ 
            n = n+1;

            coursesHtml     += __courseCardNew(course, shoppingCartEnabled);
            if(n==8){ 
                return false;
            } 
        }); 

        coursesHtml     += 
                    `   </div>
                    </div>
                </div>
            </div>`;
            
        if(Object.keys(courses).length > 8) {
            coursesHtml += `<div class="btn-center-div" id="load_more_courses_list">`;
            coursesHtml += `<a href="${window.__site_url}course/listing" class="btn btn-outline btn-md">View All</a>`;
            coursesHtml += `</div>`;
        }
    } 
    else {
        coursesHtml += `<div class="no-top-courses-wrapper">`;
        coursesHtml += `<p>We are currently creating new courses to be launched soon.</p>`;
        coursesHtml += `</div>`; 
    }
    // console.log('window.abcde');

    setTimeout(function(){
        // console.log('window.12345');
        // console.log(window.__timeZones);
        loadTimeZones()
    },300);
    return coursesHtml;   
     
}

export const excludeSubscribedCourses = (courses, enrolledCourses) => {
    if(window.isBulkPurchase) {
        return courses;
    }
    return courses.filter((elem) => (enrolledCourses[elem.item_type] ? !enrolledCourses[elem.item_type].includes(elem.item_id) : true));
}

export const __courseCardNew = (course, shoppingCartEnabled) => {
    const currency = localStorage.getItem('current_currency') ? JSON.parse(localStorage.getItem('current_currency')) : '';
    var item_type = course["item_type"];
    var cardsHtml = "";

    if (item_type === "bundle") 
    {
        cardsHtml += bundlesHtml(course, currency, shoppingCartEnabled);
    } else if (item_type === "course" || item_type === "online") 
    {
        cardsHtml += coursecardsHtml(course, currency, shoppingCartEnabled);
    } else if (item_type === "blended_course" || item_type === "blended") 
    { 
        cardsHtml += blendedCoursesHtml(course, currency, shoppingCartEnabled);
    } else if (item_type === "booking_event" )
    {
        cardsHtml += bookingEventsHtml(course, currency, shoppingCartEnabled);
    }
    return cardsHtml;
}

export const bundlesHtml = (course, currency='', shoppingCartEnabled) => {
    var __current_currency          = (currency !== '') ? currency : '';
    var description_length          = 120;
    var short_description           = (course["item_short_description"] != null)?course["item_short_description"].replace(/(<([^>]+)>)/ig,""):'';
    short_description               = short_description.length > description_length ? short_description.substring(0, description_length) + "..." : short_description;
    var id                          = course['item_id'];
    let itemUrl                     =   window.__site_url+course['item_slug'];
    let itemSlug                    =   course['item_slug'];
    let itemName                    =   course['item_name'];
    let courseLabelWithCourseCount =   course['item_tag'];
    let numCourses                  =   course['item_course_count'];
    let numTrainingCourses          = course['item_training_courses_count'];
    let numTrainingEvents           = course['item_training_events_count'];
    let totalNum                    = numCourses+numTrainingCourses+numTrainingEvents;
    let item_is_free                =   course['item_is_free'];
    let item_price                  =   course['item_price'];
    let rating_show                  =   course['c_rating_enabled'] ?? '0';
    return (
        `<div class="mb-4 col-lg-3">
           
            <div class="event-block-wrapper event-hoverable course-event-wrapper ${course['c_bundle_type'] == 1 ? 'course-discounted' : ''}">
            <div class="carousel-block p-0">
                <a class="text-decoration-none" href="/${itemSlug}">
                <div class="img-carousel">
                    <img src="${window.getFullPath(course['item_image'], "bundle")}" class="img-fluid">
                     ${course['c_bundle_type'] == 1 ? `
                        <span class="icon-hotsale">
                            <img src="https://d2cl07xv2ii8xi.cloudfront.net/uploads/default/catalog/icon-hot-sale.png" alt="Hot sale icon" />
                        </span>` : ''}
                </div>
                </a>
                <div class="desc-carousel">
                <a class="text-decoration-none" href="/${itemSlug}">
                    <h1>${itemName}</h1>
                    <p class="short-desc">${short_description}</p>
                    <div class="align-items-center gap-2 mb-3 sub-label">
                    <div class=" icon-teacher-expiry d-flex align-items-center gap-1">
                      <svg xmlns="http://www.w3.org/2000/svg" width="10.899" height="11.954" viewBox="0 0 10.899 11.954">
                        <g transform="translate(-2.3 -1.3)">
                            <path d="M4.583,2,3,4.111V11.5a1.055,1.055,0,0,0,1.055,1.055h7.388A1.055,1.055,0,0,0,12.5,11.5V4.111L10.915,2Z" transform="translate(0 0)" fill="none" stroke="#76777a" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.4"></path>
                            <line x2="8.177" transform="translate(3.661 4.211)" fill="none" stroke="#76777a" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.4"></line>
                        </g>
                        </svg>
                        <p class="p-0 m-0 d-inline-flex gap-1">${courseLabelWithCourseCount}</p>
                    </div>
                    <div class="icon-teacher-expiry d-flex align-items-center gap-1">
                        <svg xmlns="http://www.w3.org/2000/svg" width="10.899" height="11.954" viewBox="0 0 10.899 11.954">
                        <g transform="translate(-2.3 -1.3)">
                            <path d="M4.583,2,3,4.111V11.5a1.055,1.055,0,0,0,1.055,1.055h7.388A1.055,1.055,0,0,0,12.5,11.5V4.111L10.915,2Z" transform="translate(0 0)" fill="none" stroke="#76777a" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.4"></path>
                            <line x2="8.177" transform="translate(3.661 4.211)" fill="none" stroke="#76777a" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.4"></line>
                        </g>
                        </svg>
                        <p class="p-0 m-0 d-inline-flex gap-1">${numTrainingCourses} Training Courses</p>
                    </div>
                    <div class="icon-teacher-expiry d-flex align-items-center gap-1">
                        <svg xmlns="http://www.w3.org/2000/svg" width="10.899" height="11.954" viewBox="0 0 10.899 11.954">
                        <g transform="translate(-2.3 -1.3)">
                            <path d="M4.583,2,3,4.111V11.5a1.055,1.055,0,0,0,1.055,1.055h7.388A1.055,1.055,0,0,0,12.5,11.5V4.111L10.915,2Z" transform="translate(0 0)" fill="none" stroke="#76777a" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.4"></path>
                            <line x2="8.177" transform="translate(3.661 4.211)" fill="none" stroke="#76777a" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.4"></line>
                        </g>
                        </svg>
                        <p class="p-0 m-0 d-inline-flex gap-1">${numTrainingEvents} Training Events</p>
                    </div>
                    </div>
                    <div class="d-flex align-items-end justify-content-between course-price-wrapper mt-0">
                    ${course['item_price_label_show'] == '1' ?
                        `<div class="pricing-slot pricing-left">
                        ${window._show_member_price == 1 && course['member_status'] == '1' && item_is_free == '0' ? `<span>${window._current_pricing_label}</span>` : ``}
                            ${item_is_free == '0' && course['item_discount'] > 0 ? `<div class="price">${__current_currency.symbol_code}${course['c_discount_percent'] > 0 ? course['item_discount'] : course['item_discount']}<span>${__current_currency.symbol_code}${item_price}</span></div>`  : `
                            ${item_is_free == '0' ? `<div class="price">${__current_currency.symbol_code}${item_price}</div>` : `<div class="price">${window.__free_label}</div>`}`}                            
                        </div>
                        ${window._show_member_price == 1 && course['member_status'] == '1' && item_is_free == '0' ?
                    `<span class="separator-price-set"></span>
                    <div class="pricing-slot pricing-right">
                        <span>${window._member_pricing_label}</span>
                        ${course['member_price'] > 0 ? `<div class="price">${__current_currency.symbol_code}${course['member_price']}</div>` : ``}
                        ${course['member_price'] < 1 && window.__free_label_enabled == 1 ? `<div class="price">${window.__free_label}</div>` : ``}
                    </div>` : ``}` : ``}
                    </div>
                </a>
                <div class="rating-cart-wrapper d-flex align-items-center justify-content-between pt-3">
                    <div class="rating-digits d-flex align-items-center gap-2">
                    ${(course['item_ratting'] > 0 && rating_show > 0)  ? 
                    `<span>${course['item_ratting']}</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="cursor-pointer" viewBox="0 0 16 16" icon="star"><path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"></path></svg>` : ``}
                    </div>
                    ${generateCardProductButton(course, shoppingCartEnabled)}
                </div>
                </div>
                <div class="course-bundle-tag d-flex align-items-center justify-content-center gap-1">
                <span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-stack" viewBox="0 0 16 16">
                    <path d="M14.12 10.163l1.715.858c.22.11.22.424 0 .534L8.267 15.34a.598.598 0 01-.534 0L.165 11.555a.299.299 0 010-.534l1.716-.858 5.317 2.659c.505.252 1.1.252 1.604 0l5.317-2.66zM7.733.063a.598.598 0 01.534 0l7.568 3.784a.3.3 0 010 .535L8.267 8.165a.598.598 0 01-.534 0L.165 4.382a.299.299 0 010-.535L7.733.063z"></path>
                    <path d="M14.12 6.576l1.715.858c.22.11.22.424 0 .534l-7.568 3.784a.598.598 0 01-.534 0L.165 7.968a.299.299 0 010-.534l1.716-.858 5.317 2.659c.505.252 1.1.252 1.604 0l5.317-2.659z"></path>
                    </svg>
                </span>
                <span>${totalNum} in 1</span>
                </div>
                <div class="hover-overlay">
                <div class="carousel-block p-0">
                    <div class="desc-carousel">
                    <a class="text-decoration-none" href="/${itemSlug}">
                    <h1>${itemName}</h1>
                    <p class="short-desc">${short_description}</p>
                    <div class="d-flex flex-column mb-3 sub-label">
                    <div class="d-flex align-items-center gap-3 mb-2">
                    <div class="icon-teacher-expiry d-flex align-items-center gap-1">
                        <svg xmlns="http://www.w3.org/2000/svg" width="10.899" height="11.954" viewBox="0 0 10.899 11.954">
                        <g transform="translate(-2.3 -1.3)">
                            <path d="M4.583,2,3,4.111V11.5a1.055,1.055,0,0,0,1.055,1.055h7.388A1.055,1.055,0,0,0,12.5,11.5V4.111L10.915,2Z" transform="translate(0 0)" fill="none" stroke="#76777a" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.4"></path>
                            <line x2="8.177" transform="translate(3.661 4.211)" fill="none" stroke="#76777a" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.4"></line>
                        </g>
                        </svg>
                        <p class="p-0 m-0 d-inline-flex gap-1">${courseLabelWithCourseCount}</p>
                    </div>
                    <div class="icon-teacher-expiry d-flex align-items-center gap-1">
                        <svg xmlns="http://www.w3.org/2000/svg" width="10.899" height="11.954" viewBox="0 0 10.899 11.954">
                        <g transform="translate(-2.3 -1.3)">
                            <path d="M4.583,2,3,4.111V11.5a1.055,1.055,0,0,0,1.055,1.055h7.388A1.055,1.055,0,0,0,12.5,11.5V4.111L10.915,2Z" transform="translate(0 0)" fill="none" stroke="#76777a" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.4"></path>
                            <line x2="8.177" transform="translate(3.661 4.211)" fill="none" stroke="#76777a" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.4"></line>
                        </g>
                        </svg>
                        <p class="p-0 m-0 d-inline-flex gap-1">${numTrainingCourses} Training Courses</p>
                    </div>
                    </div>
                    <div class="d-flex align-items-center gap-1">
                    <div class="icon-teacher-expiry d-flex align-items-center gap-1">
                        <svg xmlns="http://www.w3.org/2000/svg" width="10.899" height="11.954" viewBox="0 0 10.899 11.954">
                        <g transform="translate(-2.3 -1.3)">
                            <path d="M4.583,2,3,4.111V11.5a1.055,1.055,0,0,0,1.055,1.055h7.388A1.055,1.055,0,0,0,12.5,11.5V4.111L10.915,2Z" transform="translate(0 0)" fill="none" stroke="#76777a" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.4"></path>
                            <line x2="8.177" transform="translate(3.661 4.211)" fill="none" stroke="#76777a" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.4"></line>
                        </g>
                        </svg>
                        <p class="p-0 m-0 d-inline-flex gap-1">${numTrainingEvents} Training Events</p>
                    </div>
                    </div>
                    </div>
                    <div class="d-flex align-items-end justify-content-between course-price-wrapper mt-0">
                    ${course['item_price_label_show'] == '1' ?
                        `<div class="pricing-slot pricing-left">
                        ${window._show_member_price == 1 && course['member_status'] == '1' && item_is_free == '0' ? `<span>${window._current_pricing_label}</span>` : ``}
                            ${item_is_free == '0' && course['item_discount'] > 0 ? `<div class="price">${__current_currency.symbol_code}${course['c_discount_percent'] > 0 ? course['item_discount'] : course['item_discount']}<span>${__current_currency.symbol_code}${item_price}</span></div>`  : `
                            ${item_is_free == '0' ? `<div class="price">${__current_currency.symbol_code}${item_price}</div>` : `<div class="price">${window.__free_label}</div>`}`}                            
                        </div>
                        ${window._show_member_price == 1 && course['member_status'] == '1' && item_is_free == '0' ?
                    `<span class="separator-price-set"></span>
                    <div class="pricing-slot pricing-right">
                        <span>${window._member_pricing_label}</span>
                        ${course['member_price'] > 0 ? `<div class="price">${__current_currency.symbol_code}${course['member_price']}</div>` : ``}
                        ${course['member_price'] < 1 && window.__free_label_enabled == 1 ? `<div class="price">${window.__free_label}</div>` : ``}
                    </div>` : ``}` : ``}
                    </div>
                </a>
                        <div class="rating-cart-wrapper">
                        ${generateCardHoverProductButton(course, shoppingCartEnabled)}
                        </div>
                    </div>
                </div>
                </div>
            </div>
            </div>
        </div>`);
}

export const coursecardsHtml = (course, currency = '',shoppingCartEnabled) =>{
    var __current_currency          = (currency !== '') ? currency : '';
    var id                          = course['item_id'];
    var description_length          = 120;
    var short_description           = (course["item_short_description"] != null)?course["item_short_description"].replace(/(<([^>]+)>)/ig,""):'';
    short_description               = short_description.length > description_length ? short_description.substring(0, description_length) + "..." : short_description;
    let itemUrl                     =   window.__site_url+course['item_slug'];
    let itemSlug                    =   course['item_slug'];
    let itemName                    =   course['item_name'];
    let lectureLabelWithLectureCout =   course['item_tag'];
    let item_is_free                =   course['item_is_free'];
    let item_price                  =   course['item_price'];
    let rating_show                  =   course['c_rating_enabled'] ?? '0';
    return (
            `<div class="mb-4 col-lg-3" id="${id}">
                <div class="event-block-wrapper event-hoverable course-event-wrapper">
                <div class="carousel-block p-0">
                    <a class="text-decoration-none" href="/${itemSlug}">
                    <div class="img-carousel">
                        <img src="${ course['item_full_image']}" class="img-fluid">
                    </div>
                    </a>
                    <div class="desc-carousel">
                    <a class="text-decoration-none" href="/${itemSlug}">
                        <h1>${itemName}</h1>
                        <p class="short-desc">${short_description}</p>
                        <div class="d-flex align-items-center gap-3 mb-3 sub-label">
                        <div class=" icon-teacher-expiry d-flex align-items-center gap-1">
                            <svg xmlns="http://www.w3.org/2000/svg" width="10.031" height="12.189" viewBox="0 0 10.031 12.189">
                            <g fill="none" stroke="#76777a" stroke-width="1.4">
                                <path data-name="Path 21658" d="M4.855 0H1.079A1.079 1.079 0 000 1.079V9.71a1.079 1.079 0 001.079 1.079h6.474A1.079 1.079 0 008.632 9.71V3.776z" transform="translate(.7 .7)"></path>
                                <path data-name="Path 21659" d="M4.855 0v3.776h3.776" transform="translate(.7 .7)"></path>
                            </g>
                            </svg>
                            <p class="p-0 m-0 d-inline-flex gap-1">${lectureLabelWithLectureCout} </p>
                        </div>
                        </div>
                        <div class="d-flex align-items-end justify-content-between course-price-wrapper mt-0">
                        ${course['item_price_label_show'] == '1' ?
                        `<div class="pricing-slot pricing-left">
                        ${window._show_member_price == 1 && course['member_status'] == '1' && item_is_free == '0' ? `<span>${window._current_pricing_label}</span>` : ``}
                            ${item_is_free == '0' && course['item_discount'] > 0 ? `<div class="price">${__current_currency.symbol_code}${course['item_discount']}<span>${__current_currency.symbol_code}${item_price}</span></div>` : `
                            ${item_is_free == '0' ? `<div class="price">${__current_currency.symbol_code}${item_price}</div>` : `<div class="price">${__free_label}</div>`}`}                            
                        </div>
                        ${window._show_member_price == 1 && course['member_status'] == '1' && item_is_free == '0' ?
                    `<span class="separator-price-set"></span>
                    <div class="pricing-slot pricing-right">
                        <span>${window._member_pricing_label}</span>
                        ${course['member_price'] > 0 ? `<div class="price">${__current_currency.symbol_code}${course['member_price']}</div>` : ``}
                        ${course['member_price'] < 1 && window.__free_label_enabled == 1 ? `<div class="price">${window.__free_label}</div>` : ``}
                    </div>` : ``}` : ``}
                        </div>
                    </a>
                    <div class="rating-cart-wrapper d-flex align-items-center justify-content-between pt-3">
                        <div class="rating-digits d-flex align-items-center gap-2">
                        ${(course['item_ratting'] > 0  && rating_show > 0) ? 
                        `<span>${course['item_ratting']}</span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="cursor-pointer" viewBox="0 0 16 16" icon="star"><path d="M3.612 15.443c-.386.198-.824-.149-.746-.592l.83-4.73L.173 6.765c-.329-.314-.158-.888.283-.95l4.898-.696L7.538.792c.197-.39.73-.39.927 0l2.184 4.327 4.898.696c.441.062.612.636.282.95l-3.522 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256z"></path></svg>` : ``}
                        </div>
                        ${generateCardProductButton(course, shoppingCartEnabled)}
                    </div>
                    </div>
                    <div class="hover-overlay">
                    <div class=" carousel-block p-0">
                        <div class="desc-carousel">
                        <a class="text-decoration-none" href="/${itemSlug}">
                        <h1>${itemName}</h1>
                        <p class="short-desc">${short_description}</p>
                        <div class="d-flex align-items-center gap-3 mb-3 sub-label">
                        <div class=" icon-teacher-expiry d-flex align-items-center gap-1">
                            <svg xmlns="http://www.w3.org/2000/svg" width="10.031" height="12.189" viewBox="0 0 10.031 12.189">
                            <g fill="none" stroke="#76777a" stroke-width="1.4">
                                <path data-name="Path 21658" d="M4.855 0H1.079A1.079 1.079 0 000 1.079V9.71a1.079 1.079 0 001.079 1.079h6.474A1.079 1.079 0 008.632 9.71V3.776z" transform="translate(.7 .7)"></path>
                                <path data-name="Path 21659" d="M4.855 0v3.776h3.776" transform="translate(.7 .7)"></path>
                            </g>
                            </svg>
                            <p class="p-0 m-0 d-inline-flex gap-1">${lectureLabelWithLectureCout} </p>
                        </div>
                        </div>
                        <div class="d-flex align-items-end justify-content-between course-price-wrapper mt-0">
                        ${course['item_price_label_show'] == '1' ?
                        `<div class="pricing-slot pricing-left">
                        ${window._show_member_price == 1 && course['member_status'] == '1' && item_is_free == '0' ? `<span>${window._current_pricing_label}</span>` : ``}
                            ${item_is_free == '0' && course['item_discount'] > 0 ? `<div class="price">${__current_currency.symbol_code}${course['item_discount']}<span>${__current_currency.symbol_code}${item_price}</span></div>` : `
                            ${item_is_free == '0' ? `<div class="price">${__current_currency.symbol_code}${item_price}</div>` : `<div class="price">${__free_label}</div>`}`}                            
                        </div>
                        ${window._show_member_price == 1 && course['member_status'] == '1' && item_is_free == '0' ?
                    `<span class="separator-price-set"></span>
                    <div class="pricing-slot pricing-right">
                        <span>${window._member_pricing_label}</span>
                        ${course['member_price'] > 0 ? `<div class="price">${__current_currency.symbol_code}${course['member_price']}</div>` : ``}
                        ${course['member_price'] < 1 && window.__free_label_enabled == 1 ? `<div class="price">${window.__free_label}</div>` : ``}
                    </div>` : ``}` : ``}
                        </div>
                    </a>
                        <div class="rating-cart-wrapper">
                        ${generateCardHoverProductButton(course, shoppingCartEnabled)}
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </div>`);
}

export const blendedCoursesHtml = (course, currency = '', shoppingCartEnabled) => {
    var __current_currency          = (currency !== '') ? currency : '';
    var image_path                  = course['item_image'] == "default.jpg" ? window.__default_course_path : window.__blended_course_path;
    var description_length          = 120;
    var short_description           = (course["item_short_description"] != null)?course["item_short_description"].replace(/(<([^>]+)>)/ig,""):'';
    short_description               = short_description.length > description_length ? short_description.substring(0, description_length) + "..." : short_description;
    var id                          = course['item_id'];
    
    let itemUrl                     =   window.__site_url+course['item_slug'];
    let itemSlug                    =   course['item_slug'];
    let itemName                    =   course['item_name'];
    let item_is_free                =   course['item_is_free'];
    let item_price                  =   course['item_price']; 
    return (
        `<div class="mb-4 col-lg-3">
        <div class="event-block-wrapper event-hoverable course-event-wrapper">
          <div class="carousel-block p-0">
            <a class="text-decoration-none" href="/${itemSlug}">
              <div class="img-carousel">
                <img src="${ course['item_full_image']}" class="img-fluid">
              </div>
            </a>
            <div class="desc-carousel">
            <a class="text-decoration-none" href="/${itemSlug}">
            <h1>${itemName}</h1>
            <p class="short-desc">${short_description}</p>
            <div class="d-flex align-items-center gap-3 mb-3 sub-label">
            </div>
            <div class="d-flex align-items-end justify-content-between course-price-wrapper mt-0">
            ${course['item_price_label_show'] == '1' ?
            `<div class="pricing-slot pricing-left">
            ${window._show_member_price == 1 && course['member_status'] == '1' && item_is_free == '0' ? `<span>${window._current_pricing_label}</span>` : ``}
                ${item_is_free == '0' && course['item_discount'] > 0 ? `<div class="price">${__current_currency.symbol_code}${course['item_discount']}<span>${__current_currency.symbol_code}${item_price}</span></div>` : `
                ${item_is_free == '0' ? `<div class="price">${__current_currency.symbol_code}${item_price}</div>` : `<div class="price">${__free_label}</div>`}`}                            
            </div>
            ${window._show_member_price == 1 && course['member_status'] == '1' && item_is_free == '0' ?
        `<span class="separator-price-set"></span>
        <div class="pricing-slot pricing-right">
            <span>${window._member_pricing_label}</span>
            ${course['member_price'] > 0 ? `<div class="price">${__current_currency.symbol_code}${course['member_price']}</div>` : ``}
            ${course['member_price'] < 1 && window.__free_label_enabled == 1 ? `<div class="price">${window.__free_label}</div>` : ``}
        </div>` : ``}` : ``}
            </div>
        </a>
              <div class="rating-cart-wrapper d-flex align-items-center justify-content-between pt-3">
                <div class="rating-digits d-flex align-items-center gap-2">
                ${course['item_certified'] == '1' ? 
                        `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-award-fill" viewBox="0 0 16 16"><path d="M8 0l1.669.864 1.858.282.842 1.68 1.337 1.32L13.4 6l.306 1.854-1.337 1.32-.842 1.68-1.858.282L8 12l-1.669-.864-1.858-.282-.842-1.68-1.337-1.32L2.6 6l-.306-1.854 1.337-1.32.842-1.68L6.331.864 8 0z"></path><path d="M4 11.794V16l4-1 4 1v-4.206l-2.018.306L8 13.126 6.018 12.1 4 11.794z"></path></svg><span>Certified</span>` : ``}
                </div>
                ${generateCardProductButton(course, shoppingCartEnabled)}
              </div>
            </div>
            <div class="hover-overlay">
              <div class="carousel-block p-0">
                <div class="desc-carousel">
                <a class="text-decoration-none" href="/${itemSlug}">
                <h1>${itemName}</h1>
                <p class="short-desc">${short_description}</p>
                <div class="d-flex align-items-center gap-3 mb-3 sub-label">
                </div>
                <div class="d-flex align-items-end justify-content-between course-price-wrapper mt-0">
                ${course['item_price_label_show'] == '1' ?
                `<div class="pricing-slot pricing-left">
                ${window._show_member_price == 1 && course['member_status'] == '1' && item_is_free == '0' ? `<span>${window._current_pricing_label}</span>` : ``}
                    ${item_is_free == '0' && course['item_discount'] > 0 ? `<div class="price">${__current_currency.symbol_code}${course['item_discount']}<span>${__current_currency.symbol_code}${item_price}</span></div>` : `
                    ${item_is_free == '0' ? `<div class="price">${__current_currency.symbol_code}${item_price}</div>` : `<div class="price">${__free_label}</div>`}`}                            
                </div>
                ${window._show_member_price == 1 && course['member_status'] == '1' && item_is_free == '0' ?
            `<span class="separator-price-set"></span>
            <div class="pricing-slot pricing-right">
                <span>${window._member_pricing_label}</span>
                ${course['member_price'] > 0 ? `<div class="price">${__current_currency.symbol_code}${course['member_price']}</div>` : ``}
                ${course['member_price'] < 1 && window.__free_label_enabled == 1 ? `<div class="price">${window.__free_label}</div>` : ``}
            </div>` : ``}` : ``}
                </div>
            </a>
                  <div class="rating-cart-wrapper">
                  ${generateCardHoverProductButton(course, shoppingCartEnabled)}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>`
    );
}

export const bookingEventsHtml = (course, currency = '', shoppingCartEnabled) => {
    var __current_currency          = (currency !== '') ? currency : '';
    var image_path                  = course['item_image'] === "default.jpg" ? window.__default_course_path : window.__blended_course_path;
    var description_length          = 120;
    var short_description           = (course["item_short_description"] != null)?course["item_short_description"].replace(/(<([^>]+)>)/ig,""):'';
    short_description               = short_description.length > description_length ? short_description.substring(0, description_length) + "..." : short_description;
    var id                          = course['item_id'];

    var default_start_datetime = moment(course['item_start_date'] + ' ' + course['item_start_time'], "YYYY-MM-DD h:mm:ss A").tz('UTC', true);              
    var default_end_datetime = moment(course['item_end_date'] + ' ' + course['item_end_time'], "YYYY-MM-DD h:mm:ss A").tz('UTC', true);

    var start_date_tz = default_start_datetime.format("DD-MM-YYYY");
    var start_time_tz = default_start_datetime.format("h:mm A");
    var end_date_tz = default_end_datetime.format("DD-MM-YYYY");
    var end_time_tz = default_end_datetime.format("h:mm A");

    if (__timezone != '') {
        // __timezone = parseInt(__timezone)+0;
        //console.log(selected_timezone);
        // var tz_start_datetime = moment(default_start_datetime).utcOffset(__timezone);
        var tz_start_datetime = moment(default_start_datetime).tz(__timezone);
        // var tz_end_datetime = moment(default_end_datetime).utcOffset(__timezone);
        var tz_end_datetime = moment(default_end_datetime).tz(__timezone);
        start_date_tz = tz_start_datetime.format("DD-MM-YYYY");
        start_time_tz = tz_start_datetime.format("h:mm A");
        end_date_tz = tz_end_datetime.format("DD-MM-YYYY");
        end_time_tz = tz_end_datetime.format("h:mm A");                 
        
    }
    var now = moment(default_end_datetime);
    var then = moment(default_start_datetime);
    
    var duration = moment.duration(now.diff(then));
    var dayDiff = duration.days();
    var hourDiff = duration.hours();
    var minutesDiff = duration.minutes();
    var diff = '';
    if (dayDiff > 0) {                
        diff += dayDiff + ' D ';
    }
    if (hourDiff > 0) {                
        diff += hourDiff + ' Hr ';
    }
    if (minutesDiff > 0) {                
        diff += minutesDiff + ' Min';
    }

    var date_diff                    = (Date.parse(end_date_tz) - Date.parse(start_date_tz))/86400000;

    var startDate                   = start_date_tz.split('-');
    var startYear                   = startDate[2].substring(2);
    var startMonth                  = GetFullMonthName(Number(startDate[1]).toString());
    var startDay                    = startDate[0];
    let start_date_text             = startDay+' '+startMonth+' '+startYear;

    var endDate                      = end_date_tz.split('-');
    var endMonth                     = GetMonthName(Number(endDate[1]).toString());
    var endDay                       = endDate[0];
    let item_is_free                =   course['item_is_free'];
    let item_price                  =   course['item_price'];
    let itemSlug                    =   course['item_slug'];
    let itemName                    =   course['item_name'];
    let time_text                   = start_time_tz+' - '+end_time_tz;
    let showEventCountTag           = false;
    if(course['item_show_seat_availability'] = '1'){
        showEventCountTag           = true;
    }
    let eventCountTagValue           = '';
    if(course['item_availability_seats'] < 1) {
        eventCountTagValue              = 'Sold out';
    } else if(course['item_availability_seats'] <= 5) {
        eventCountTagValue              = 'Limited Seats';
    } else {
        eventCountTagValue              = course['item_availability_seats']+' Seats Left';
    }
    
    return(
        `<div class="mb-4 col-lg-3">
        <div class="event-block-wrapper event-hoverable course-event-wrapper">
          <div class="${course['item_availability_seats'] < 1 ? 'sold ' : ''}carousel-block p-0${course['item_availability_seats'] <= 5 && course['item_availability_seats'] > 0 ? ' limited' : ''}">
            <a class="text-decoration-none" href="/${itemSlug}">
              <div class="img-carousel">
                <img src="${image_path+course['item_image']}" class="img-fluid">
                <span bg="primary" class="badge blue badge-round badge">${start_date_text}</span>
              </div>
            </a>
            <div class="desc-carousel">
            <a class="text-decoration-none" href="/${itemSlug}">
            <h1>${itemName}</h1>
            <p class="short-desc">${short_description}</p>
            <div class="d-flex align-items-center gap-3 mb-3 sub-label">
            <div class="icon-teacher-expiry d-flex align-items-center gap-1">
            ${course['item_tag_type'] == 'single-live' ? 
            `<svg
            xmlns="http://www.w3.org/2000/svg"
            width={15.41}
            height={11.887}
            viewBox="0 0 15.41 11.887"
          >
            <g
              data-name="Group 27205"
              transform="translate(-83.3 -80.01)"
              fill="none"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.4}
            >
              <circle
                data-name="Ellipse 437"
                cx={1.501}
                cy={1.501}
                r={1.501}
                transform="translate(89.504 84.453)"
              />
              <path
                data-name="Path 49029"
                d="M93.976 82.983a4.2 4.2 0 010 5.949m-5.942-.007a4.2 4.2 0 010-5.949M95.959 81a7.006 7.006 0 010 9.907m-9.907 0a7.006 7.006 0 010-9.907"
              />
            </g>
          </svg>`
          :
          `<svg
          xmlns="http://www.w3.org/2000/svg"
          width={10.607}
          height={12.654}
          viewBox="0 0 10.607 12.654"
        >
          <g
            data-name="map-pin (1)"
            transform="translate(-2.3 -.3)"
            fill="none"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.4}
          >
            <path
              data-name="Path 49018"
              d="M12.207 5.6c0 3.581-4.6 6.65-4.6 6.65S3 9.184 3 5.6a4.604 4.604 0 119.207 0z"
            />
            <circle
              data-name="Ellipse 434"
              cx={1.876}
              cy={1.876}
              r={1.876}
              transform="translate(5.728 3.813)"
            />
          </g>
        </svg>`
        }
                    <p class="p-0 m-0 d-inline-flex gap-1">${course['item_tag']}</p>
                  </div>
                  <div class="icon-teacher-expiry d-flex align-items-center gap-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="12.4" height="12.4" viewBox="0 0 12.4 12.4">
                      <g transform="translate(-1.128 -1.128)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.4">
                        <circle data-name="Ellipse 435" cx="5.5" cy="5.5" r="5.5" transform="translate(1.828 1.828)"></circle>
                        <path data-name="Path 49019" d="M7.405 4.167v3.238l2.159 1.079"></path>
                      </g>
                    </svg>
                    <p class="p-0 m-0 d-inline-flex gap-1">${time_text}</p>
                  </div>
            </div>
            <div class="d-flex align-items-end justify-content-between course-price-wrapper mt-0">
            ${course['item_price_label_show'] == '1' ?
            `<div class="pricing-slot pricing-left">
            ${window._show_member_price == 1 && course['member_status'] == '1' && item_is_free == '0' ? `<span>${window._current_pricing_label}</span>` : ``}
                ${item_is_free == '0' && course['item_discount'] > 0 ? `<div class="price">${__current_currency.symbol_code}${course['item_discount']}<span>${__current_currency.symbol_code}${item_price}</span></div>` : `
                ${item_is_free == '0' ? `<div class="price">${__current_currency.symbol_code}${item_price}</div>` : `<div class="price">${__free_label}</div>`}`}                            
            </div>
            ${window._show_member_price == 1 && course['member_status'] == '1' && item_is_free == '0' ?
        `<span class="separator-price-set"></span>
        <div class="pricing-slot pricing-right">
            <span>${window._member_pricing_label}</span>
            ${course['member_price'] > 0 ? `<div class="price">${__current_currency.symbol_code}${course['member_price']}</div>` : ``}
            ${course['member_price'] < 1 && window.__free_label_enabled == 1 ? `<div class="price">${window.__free_label}</div>` : ``}
        </div>` : ``}` : ``}
            </div>
        </a>
              <div class="rating-cart-wrapper d-flex align-items-center justify-content-between pt-3">
                <div class="rating-digits d-flex align-items-center gap-2">
                ${course['item_certified'] == '1' ? 
                        `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-award-fill" viewBox="0 0 16 16">
                        <path d="M8 0l1.669.864 1.858.282.842 1.68 1.337 1.32L13.4 6l.306 1.854-1.337 1.32-.842 1.68-1.858.282L8 12l-1.669-.864-1.858-.282-.842-1.68-1.337-1.32L2.6 6l-.306-1.854 1.337-1.32.842-1.68L6.331.864 8 0z"></path>
                        <path d="M4 11.794V16l4-1 4 1v-4.206l-2.018.306L8 13.126 6.018 12.1 4 11.794z"></path>
                      </svg>
                      <span>Certified</span>` : ``}
                </div>
                ${generateCardProductButton(course, shoppingCartEnabled)}
              </div>
            </div>
            <div class="hover-overlay">
              <div class="${course['item_availability_seats'] === 0 ? `sold` : ``}} carousel-block p-0">
                <div class="desc-carousel">
                <a class="text-decoration-none" href="/${itemSlug}">
                <h1>${itemName}</h1>
                <p class="short-desc">${short_description}</p>
                <div class="d-flex align-items-center gap-3 mb-3 sub-label">
                <div class="icon-teacher-expiry d-flex align-items-center gap-1">
                ${course['item_tag_type'] == 'single-live' ? 
                `<svg
                xmlns="http://www.w3.org/2000/svg"
                width={15.41}
                height={11.887}
                viewBox="0 0 15.41 11.887"
              >
                <g
                  data-name="Group 27205"
                  transform="translate(-83.3 -80.01)"
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={1.4}
                >
                  <circle
                    data-name="Ellipse 437"
                    cx={1.501}
                    cy={1.501}
                    r={1.501}
                    transform="translate(89.504 84.453)"
                  />
                  <path
                    data-name="Path 49029"
                    d="M93.976 82.983a4.2 4.2 0 010 5.949m-5.942-.007a4.2 4.2 0 010-5.949M95.959 81a7.006 7.006 0 010 9.907m-9.907 0a7.006 7.006 0 010-9.907"
                  />
                </g>
              </svg>`
              :
              `<svg
              xmlns="http://www.w3.org/2000/svg"
              width={10.607}
              height={12.654}
              viewBox="0 0 10.607 12.654"
            >
              <g
                data-name="map-pin (1)"
                transform="translate(-2.3 -.3)"
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.4}
              >
                <path
                  data-name="Path 49018"
                  d="M12.207 5.6c0 3.581-4.6 6.65-4.6 6.65S3 9.184 3 5.6a4.604 4.604 0 119.207 0z"
                />
                <circle
                  data-name="Ellipse 434"
                  cx={1.876}
                  cy={1.876}
                  r={1.876}
                  transform="translate(5.728 3.813)"
                />
              </g>
            </svg>`
            }
                        <p class="p-0 m-0 d-inline-flex gap-1">${course['item_tag']}</p>
                      </div>
                      <div class="icon-teacher-expiry d-flex align-items-center gap-1">
                        <svg xmlns="http://www.w3.org/2000/svg" width="12.4" height="12.4" viewBox="0 0 12.4 12.4">
                          <g transform="translate(-1.128 -1.128)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.4">
                            <circle data-name="Ellipse 435" cx="5.5" cy="5.5" r="5.5" transform="translate(1.828 1.828)"></circle>
                            <path data-name="Path 49019" d="M7.405 4.167v3.238l2.159 1.079"></path>
                          </g>
                        </svg>
                        <p class="p-0 m-0 d-inline-flex gap-1">${time_text}</p>
                      </div>
                </div>
                <div class="d-flex align-items-end justify-content-between course-price-wrapper mt-0">
                ${course['item_price_label_show'] == '1' ?
                `<div class="pricing-slot pricing-left">
                ${window._show_member_price == 1 && course['member_status'] == '1' && item_is_free == '0' ? `<span>${window._current_pricing_label}</span>` : ``}
                    ${item_is_free == '0' && course['item_discount'] > 0 ? `<div class="price">${__current_currency.symbol_code}${course['item_discount']}<span>${__current_currency.symbol_code}${item_price}</span></div>` : `
                    ${item_is_free == '0' ? `<div class="price">${__current_currency.symbol_code}${item_price}</div>` : `<div class="price">${__free_label}</div>`}`}                            
                </div>
                ${window._show_member_price == 1 && course['member_status'] == '1' && item_is_free == '0' ?
            `<span class="separator-price-set"></span>
            <div class="pricing-slot pricing-right">
                <span>${window._member_pricing_label}</span>
                ${course['member_price'] > 0 ? `<div class="price">${__current_currency.symbol_code}${course['member_price']}</div>` : ``}
                ${course['member_price'] < 1 && window.__free_label_enabled == 1 ? `<div class="price">${window.__free_label}</div>` : ``}
            </div>` : ``}` : ``}
                </div>
            </a>
                  <div class="rating-cart-wrapper">
                  ${generateCardHoverProductButton(course, shoppingCartEnabled)}
                  </div>
                </div>
              </div>
            </div>
          </div>
          ${showEventCountTag ? `<div class="course-bundle-tag event-count-tag d-flex align-items-center justify-content-center gap-1"><span>${eventCountTagValue}</span></div>` : ``}
        </div>
      </div>`
    );
}

export const generateCardProductButton = (course, cartEnabled) =>
{
    const self_enroll                       = course['item_self_enroll'] == undefined ? true : (course['item_self_enroll'] == "0" ? false : (course['item_self_enroll_date'] === null ? true : (new Date(course['item_self_enroll_date']).getTime() >= new Date(_current_date).getTime())) );
    const subscription_status               = course['item_b2b_imported'] == undefined ? true : course['item_b2b_imported'] == "0" || (course['item_b2b_imported'] == "1" && course['item_no_of_subscriptions'] > course['item_enrolled_learners_count']);
    let disabledClass                       = self_enroll ? "" : " disabled";
    let isPpsRequired                       = typeof course['item_is_pps_required'] != undefined ? course['item_is_pps_required'] : 0;
    let waitingList                         = false;
    let soldOut                             = false;
    
  if (typeof course['item_availability_seats'] != undefined && course['item_availability_seats'] < 1) {
    soldOut                                 = true;
    if (course['item_waiting_list'] == "1") {
      waitingList                           = true;
    } else {
      disabledClass                         = " disabled";
    }
  }
  let addtoCartBtnLabel                     = 'Add to Cart';
  if(inCart(course['item_id'],course['item_type'])) {
    addtoCartBtnLabel                       = 'Go to Cart';
  }

    if(course['item_type'] == 'course' || course['item_type'] == 'bundle') {
        if(self_enroll && subscription_status) {
            if(course['item_is_free'] == '0') {
                if(cartEnabled){ 
                        // return `<button type="button" class="btn btn-outline btn-md${disabledClass}" onclick="addToCart(this, ${course['item_id']},'${course['item_type']}')">Add to Cart</button>`;
                    return `<button type="button" class="btn btn-outline btn-md add-to-cart-btn${disabledClass}" data-item-id="${course['item_id']}" data-item-type="${course['item_type']}">${addtoCartBtnLabel}</button>`;
                } else {
                    if(window.__buy_now_button_enabled == 1) {
                        // return `<button type="button" class="btn btn-outline btn-md${disabledClass}" onclick="buyNow(this,${course['item_id']},'${course['item_type']}')">${window.__buy_now_button}</button>`;
                        return `<button type="button" class="btn btn-outline btn-md buy-now-btn${disabledClass}" data-item-id="${course['item_id']}" data-item-type="${course['item_type']}">${window.__buy_now_button}</button>`;
                    }
                }
            }
            if(course['item_is_free'] == '1' && window.__free_button_enabled == 1) {
                return `<button type="button" class="btn btn-outline btn-md${disabledClass}" onclick="window.location.replace('`+window.__site_url+`bulk_learners_enroll/`+course['item_id']+`/`+course['item_type']+`')">${window.__free_button}</button>`;
            }
        } else {
            return `<button type="button" class="btn btn-outline btn-md" onclick="window.location.replace('`+window.__site_url+course['item_slug']+`')">View More</button>`;
        }
    }

    if(course['item_type'] == 'blended_course' || course['item_type'] == 'blended' || course['item_type'] == 'online' || course['item_type'] == 'offline') {
        return `<button type="button" class="btn btn-outline btn-md" onclick="window.location.replace('`+window.__site_url+course['item_slug']+`')">View More</button>`;
    }

    if(course['item_type'] == 'booking_event') {
        let registration_started                = new Date(_current_date).getTime() >= new Date(course['item_reg_start_time']).getTime();
        let registration_ended                  = new Date(_current_date).getTime() >  new Date(course['item_reg_end_time']).getTime();
        const registration_status               = course['item_enable_disable_reg'] == undefined ? true : course['item_enable_disable_reg'] == "1" && registration_started && !registration_ended;
        const unable_to_register_button_label   = registration_status ? null : (course['item_enable_disable_reg'] == "1" ? (registration_started && registration_ended ? "Registration Closed" : "Coming Soon") : "View More");
        if(soldOut && !waitingList) {
            return `<button type="button" class="btn btn-outline btn-md">Sold Out</button>`;
        } else {
            if(registration_status) {
                if(waitingList) {
                    return `<button type="button" class="btn btn-outline btn-md${disabledClass}" onclick="
                    localStorage.setItem('onlyWaitingList',true);
                    window.location.replace('`+window.__site_url+`cart_react?item=`+course['item_type']+`_`+course['item_id']+`');
                    ">Add to WaitingList</button>`;
                } else {
                    if(course['item_is_free'] == '0') {
                        if(cartEnabled){ 
                            // return `<button type="button" class="btn btn-outline btn-md${disabledClass}" onclick="addToCart(this, ${course['item_id']},'${course['item_type']}')">Add to Cart</button>`;
                            return `<button type="button" class="btn btn-outline btn-md add-to-cart-btn${disabledClass}" data-item-id="${course['item_id']}" data-item-type="${course['item_type']}">${addtoCartBtnLabel}</button>`;
                        } else {
                            if(window.__buy_now_button_enabled == 1) {
                                // return `<button type="button" class="btn btn-outline btn-md${disabledClass}" onclick="buyNow(this,${course['item_id']},'${course['item_type']}')">${window.__buy_now_button}</button>`;
                                return `<button type="button" class="btn btn-outline btn-md buy-now-btn${disabledClass}" data-item-id="${course['item_id']}" data-item-type="${course['item_type']}">${window.__buy_now_button}</button>`;
                            }
                        }
                    }
                    if(course['item_is_free'] == '1' && window.__free_button_enabled == 1) {
                        return `<button type="button" class="btn btn-outline btn-md${disabledClass}" onclick="window.location.replace('`+window.__site_url+`bulk_learners_enroll/`+course['item_id']+`/`+course['item_type']+`')">${window.__free_button}</button>`;
                    }
                }
            } else {
                return `<button type="button" class="btn btn-outline btn-md" onclick="${unable_to_register_button_label == 'View More' ? window.location.replace(window.__site_url+course['item_slug']) : null}">${unable_to_register_button_label}</button>`;
            }
        }
    }
}

export const generateCardHoverProductButton = (course, cartEnabled) => {
    const self_enroll                       = course['item_self_enroll'] == undefined ? true : (course['item_self_enroll'] == "0" ? false : (course['item_self_enroll_date'] === null ? true : (new Date(course['item_self_enroll_date']).getTime() >= new Date(_current_date).getTime())) );
    const subscription_status               = course['item_b2b_imported'] == undefined ? true : course['item_b2b_imported'] == "0" || (course['item_b2b_imported'] == "1" && course['item_no_of_subscriptions'] > course['item_enrolled_learners_count']);
    let disabledClass                       = self_enroll ? "" : " disabled";
    let isPpsRequired                       = typeof course['item_is_pps_required'] != undefined ? course['item_is_pps_required'] : 0;
    let waitingList                         = false;
    let soldOut                             = false;
    let registration_started                = true;
    let registration_ended                  = false;
    
  if (typeof course['item_availability_seats'] != undefined && course['item_availability_seats'] < 1) {
    soldOut                                 = true;
    if (course['item_waiting_list'] == "1") {
      waitingList                           = true;
    } else {
      disabledClass                         = " disabled";
    }
  }
  let addtoCartBtnLabel                     = 'Add to Cart';
  if(inCart(course['item_id'],course['item_type'])) {
    addtoCartBtnLabel                       = 'Go to Cart';
  }
  if(course['item_type'] == 'booking_event'){
    registration_started                  = new Date(_current_date).getTime() >= new Date(course['item_reg_start_time']).getTime();
    registration_ended                    = new Date(_current_date).getTime() >  new Date(course['item_reg_end_time']).getTime();
  } 
  const registration_status               = course['item_enable_disable_reg'] == undefined ? true : course['item_enable_disable_reg'] == "1" && registration_started && !registration_ended;
  const unable_to_register_button_label   = registration_status ? null : (course['item_enable_disable_reg'] == "1" ? (registration_started && registration_ended ? "Registration Closed" : "Coming Soon") : "View More");
  let cardHoverProductButton              = ``;
  
  if((course['item_type'] == 'course' || course['item_type'] == 'bundle' || course['item_type'] == 'booking_event') && self_enroll && registration_status && subscription_status && (!soldOut || waitingList)) {
    if(waitingList) {
        cardHoverProductButton              += `<button type="button" class="btn btn-outline btn-md w-100 mb-3${disabledClass}" onclick="window.location.replace('`+window.__site_url+`cart_react?item=/`+course['item_type']+`_`+course['item_id']+`')">Add to WaitingList</button>`;
    } else {
        if(course['item_is_free'] == '0' && cartEnabled) {            
            // cardHoverProductButton          += `<button type="button" class="btn btn-outline btn-md w-100 mb-3${disabledClass}" onclick="addToCart(this, ${course['item_id']},'${course['item_type']}')">Add to Cart</button>`;
            cardHoverProductButton          += `<button type="button" class="btn btn-outline btn-md w-100 mb-3 add-to-cart-btn${disabledClass}" data-item-id="${course['item_id']}" data-item-type="${course['item_type']}">${addtoCartBtnLabel}</button>`;
        }
        if(course['item_is_free'] == '0' && window.__buy_now_button_enabled == 1) {
            // cardHoverProductButton          += `<button type="button" class="btn btn-secondary btn-md w-100 mb-3${disabledClass}" onclick="buyNow(this,${course['item_id']},'${course['item_type']}')">${window.__buy_now_button}</button>`;
            cardHoverProductButton          += `<button type="button" class="btn btn-secondary btn-md w-100 mb-3 buy-now-btn${disabledClass}" data-item-id="${course['item_id']}" data-item-type="${course['item_type']}">${window.__buy_now_button}</button>`;
        }
        if(course['item_is_free'] == '1' && window.__free_button_enabled == 1) {
            cardHoverProductButton          += `<button type="button" class="btn btn-secondary btn-md w-100 mb-3${disabledClass}" onclick="window.location.replace('`+window.__site_url+`bulk_learners_enroll/`+course['item_id']+`/`+course['item_type']+`')">${window.__free_button}</button>`;
        }
    }
  } else {
      if(course['item_type'] != 'booking_event' || !self_enroll) {
        cardHoverProductButton              += `<button type="button" class="btn btn-outline btn-md w-100 mb-3" onclick="window.location.replace('`+window.__site_url+course['item_slug']+`')">View More</button>`;
      } else {
          if(!registration_status) {
            cardHoverProductButton          += `<button type="button" class="btn btn-outline btn-md w-100 mb-3">${unable_to_register_button_label}</button>`;
          } else {
              if(soldOut) {
                cardHoverProductButton      += `<button type="button" class="btn btn-outline btn-md w-100 mb-3">Sold Out</button>`;
              }
          }
      }
  }
  if(window._enquiry_button_show == 1 && course['item_enquiry_needed'] == 1) {
    cardHoverProductButton                  += `<button type="button" class="w-100 border-0 mb-0 btn btn-outline btn-md" onclick="window.location.replace('`+window.__site_url+`enquiry?name=`+encodeURIComponent(course['item_name'])+`&type=`+encodeURIComponent(course['item_type'])+`&id=`+course['item_id']+`')">
    <svg xmlns="http://www.w3.org/2000/svg" width="14.2" height="14.2" viewBox="0 0 14.2 14.2">
        <path id="message-square" d="M15.8,11.533a1.422,1.422,0,0,1-1.422,1.422H5.844L3,15.8V4.422A1.422,1.422,0,0,1,4.422,3h9.956A1.422,1.422,0,0,1,15.8,4.422Z" transform="translate(-2.3 -2.3)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.4"></path>
    </svg> ${window._enquiry_button_label} 
</button>`;
  }
  return cardHoverProductButton;
}

export const generateProductButton = (course) =>
{
    var btn_text                    = window.isCartEnabled ? 'Add to cart' : window._buy_now_label;  
    var btn_text2                   = window.isCartEnabled ? 'Go to cart' : window._buy_now_label;  
    let isPpsRequired               = typeof course['item_is_pps_required'] != 'undefined' ? course['item_is_pps_required'] : 0;
    let _today                      = new Date(_current_date);
    let item_self_enroll_date       = new Date(course['item_self_enroll_date']);

    if (typeof course['item_availability_seats'] != 'undefined' && typeof course['item_waiting_list'] != 'undefined' && course['item_availability_seats'] == 0 && course['item_waiting_list'] == 1){
        return `<button class="add-cart btn theme-blue-btn1 orange-flat-btn
        " onclick="enrollItem(${course['item_id']},'${course['item_type']}', '${course['item_slug']}', ${isPpsRequired}, '2')">Add to Waiting list</button>`;
    }

    let expired_status = 0;
    if(course['item_access_validity'] === 0){
    }else if(course['item_access_validity'] === 1){
    }else if(course['item_access_validity'] === 2){
        var today = new Date(); 
        var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
        var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
        var C_dateTime = date+' '+time;
        console.log(C_dateTime, '4330');
        var end = new Date(C_dateTime);
            end.setHours(23,59,59,59);
        var starttime = new Date(course['item_validity_date']);
            starttime.setHours(23,59,59,59);
        var current_date   = parseInt((end.getTime() / 1000).toFixed(0))
        var db_date        = parseInt((new Date(starttime).getTime() / 1000).toFixed(0));
       //console.log(current_date,db_date, starttime);
        if(current_date > db_date){
            // console.log('expired');
            expired_status = 1;
        }
    }

    if(course['item_is_free'] === 1 || course['item_price'] === 0)  
    {   
        btn_text        =   window._free_course_btn_label; 
        if(course['item_type'] === 'bundle')
        {
           
            _today = new Date(_current_date);
            item_self_enroll_date = new Date(course['item_self_enroll_date']);
            
            if((course['item_type'] === 'bundle') && (expired_status === 1 || course['item_self_enroll'] !== '1') || (course['item_self_enroll_date'] != null && item_self_enroll_date < _today)){
                return '<button class="add-cart btn theme-blue-btn1 orange-flat-btn" onclick="window.location.replace(`'+window.__site_url+course['item_slug']+'`)">View More</button>';
            } else {
                _today = new Date(_current_date);
                item_self_enroll_date = new Date(course['item_self_enroll_date']);
                
                return  (course['item_self_enroll'] === 1) && (course['item_self_enroll_date'] == null || item_self_enroll_date >= _today) ? `<button class="add-cart btn theme-blue-btn1 orange-flat-btn" onclick="enrollItem(${course['item_id']},'${course['item_type']}', '${course['item_slug']}', ${isPpsRequired})">${btn_text}</button>` : '';
            }
        }
        else if(course['item_type'] === 'course')
        {
            if((((typeof(course['item_b2b_imported']) != 'undefined') && (course['item_b2b_imported'] === '1') && course['item_type'] === 'course' && typeof course['item_no_of_subscriptions'] && course['item_no_of_subscriptions'] != -1 && typeof course['item_enrolled_learners_count'] && (course['item_no_of_subscriptions'] - course['item_enrolled_learners_count']) <= 0)) || (expired_status === 1)){
                return '<button class="add-cart btn theme-blue-btn1 orange-flat-btn" onclick="window.location.replace(`'+window.__site_url+course['item_slug']+'`)">View More</button>';
            } else {
                _today = new Date(_current_date);
                                                item_self_enroll_date = new Date(course['item_self_enroll_date']);
                                                return  (course['item_self_enroll'] === 1) && (course['item_self_enroll_date'] == null || item_self_enroll_date >= _today) ? `<button class="add-cart btn theme-blue-btn1 orange-flat-btn" onclick="enrollItem(${course['item_id']},'${course['item_type']}', '${course['item_slug']}', ${isPpsRequired})">${btn_text}</button>` : ''; 
            }
        }else{
            return  (course['item_reg_status'] === 1) ?  `<button class="add-cart btn theme-blue-btn1 orange-flat-btn product_buy_button_display" onclick="enrollItem(${course['item_id']},'${course['item_type']}', '${course['item_slug']}')">${window._free_event_btn}</button>` : '' ; 
        }
       
				

    }
		// if(ca)

                // console.log(course, '4333');
                
                if(course['item_type'] == 'bundle')
                {
                    // expired_status = 0;
                    // if(course['c_access_validity'] == 0){
                    // }else if(course['c_access_validity'] == 1){
                    // }else if(course['c_access_validity'] == 2){
                    //     var today = new Date(); 
                    //     var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
                    //     var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
                    //     var C_dateTime = date+' '+time;
                    //     console.log(C_dateTime, '4330');
                    //     var end = new Date(C_dateTime);
                    //         end.setHours(23,59,59,59);
                    //     var starttime = new Date(course['c_validity_date']);
                    //         starttime.setHours(23,59,59,59);
                    //     var current_date   = parseInt((end.getTime() / 1000).toFixed(0))
                    //     var db_date        = parseInt((new Date(starttime).getTime() / 1000).toFixed(0));
                    //    //console.log(current_date,db_date, starttime);
                    //     if(current_date > db_date){
                    //         // console.log('expired');
                    //         expired_status = 1;
                    //     }
                    // }

                    _today = new Date(_current_date);
                    item_self_enroll_date = new Date(course['item_self_enroll_date']);
                    if(course['item_type'] == 'bundle' && ((expired_status == 1) || course['item_self_enroll'] != '1') || (course['item_self_enroll_date'] != null && item_self_enroll_date < _today)){
                        return '<button class="add-cart btn theme-blue-btn1 orange-flat-btn" onclick="window.location.replace(`'+window.__site_url+course['item_slug']+'`)">View More</button>';
                    } else {
											if(window.isCartEnabled){
												if(inCart(course['item_id'],course['item_type']))
																{
																		return `<button class="go-to-cart add-cart btn theme-blue-btn1 orange-flat-btn" onclick="goToCart()">${btn_text2}</button>`;  
																}
																else
																{
														return `<button class="add-cart btn theme-blue-btn1 orange-flat-btn" onclick="addToCart(this, ${course['item_id']},'${course['item_type']}')">${btn_text}</button>`;  
													}
											} else {
                                                _today = new Date(_current_date);
                                                item_self_enroll_date = new Date(course['item_self_enroll_date']);
                                               
                                                return  (course['item_self_enroll'] == 1) && (course['item_self_enroll_date'] == null || item_self_enroll_date >= _today) ?   `<button class="add-cart btn theme-blue-btn1 orange-flat-btn product_buy_button_display" onclick="buyNow(this,${course['item_id']},'${course['item_type']}')">${window._buy_now_label}</button>` : '' ; 
                        // return  `<button class="add-cart btn theme-blue-btn1 orange-flat-btn" onclick="buyNow(this,${course['item_id']},'${course['item_type']}')">Buy Now</button>`; 
											} 
                    }
                }
                else
                {
                    if(((typeof(course['item_b2b_imported']) != 'undefined') && (course['item_b2b_imported'] == '1') && course['item_type'] == 'course' && typeof course['item_no_of_subscriptions'] && course['item_no_of_subscriptions'] != -1 && typeof course['item_enrolled_learners_count'] && (course['item_no_of_subscriptions'] - course['item_enrolled_learners_count']) <= 0) || (expired_status == 1)){
                        return '<button class="add-cart btn theme-blue-btn1 orange-flat-btn" onclick="window.location.replace(`'+window.__site_url+course['item_slug']+'`)">View More</button>';
                    } else {
											if(window.isCartEnabled){
												if(inCart(course['item_id'],course['item_type']))
																{
																		return `<button class="go-to-cart add-cart btn theme-blue-btn1 orange-flat-btn" onclick="goToCart()">${btn_text2}</button>`;  
																}
																else
																{
														return `<button class="add-cart btn theme-blue-btn1 orange-flat-btn" onclick="addToCart(this, ${course['item_id']},'${course['item_type']}')">${btn_text}</button>`;  
													}
											} else {
                                                if(course['item_type'] == 'course')
                                                {
                                                    _today = new Date(_current_date);
                                                    item_self_enroll_date = new Date(course['item_self_enroll_date']);
                                                    return  (course['item_self_enroll'] == 1) && (course['item_self_enroll_date'] == null  || item_self_enroll_date >= _today)  ?  `<button class="add-cart btn theme-blue-btn1 orange-flat-btn product_buy_button_display" onclick="buyNow(this,${course['item_id']},'${course['item_type']}')">${window._buy_now_label}</button>` : '' ; 
                                                    
                                                }else
                                                {
                                                    return  (course['item_reg_status'] == 1) ?  `<button class="add-cart btn theme-blue-btn1 orange-flat-btn product_buy_button_display" onclick="buyNow(this,${course['item_id']},'${course['item_type']}')">${window._event_buy_now_label}</button>` : '' ; 
                                                } 
                                                
											} 
                    }
                }					
}

export const getQueryStringValue = (key) => {
    return decodeURIComponent(window.location.search.replace(new RegExp("^(?:.*[&\\?]" + encodeURIComponent(key).replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));
}

export const QueryStringToJSON = () => {            
    var pairs = window.location.search.slice(1).split('&');
    
    var result = {};
    pairs.forEach(function(pair) {
        pair = pair.split('=');
        result[pair[0]] = decodeURIComponent(pair[1] || '');
    });

    return JSON.parse(JSON.stringify(result));
}

export const get_cookies = (cname) => {
    alert('get_cookies sdpk');
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

export const set_cookies = (cname, cvalue, exdays) => {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires=" + d.toGMTString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

export const delete_cookies = function(name) {
    document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/;';
    document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/;domain=.mykademy.com;';
    // document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/;domain=local.mykademy.com;';
};






 $(document).on('click', '#bulk_info_unavailable', function(){
    let info = $(this).prop('checked');
    if(info == true){
        $('#pps_detailed_form_bulk input, #pps_detailed_form_bulk select').attr('disabled', true);
        $('#pps_detailed_form_bulk input, #pps_detailed_form_bulk select').removeClass('border-error');
        $('#pps_detailed_form_bulk .error-msg').css('visibility', 'hidden');
    } else {
        $('#pps_detailed_form_bulk input, #pps_detailed_form_bulk select').removeAttr('disabled');
    }
    $('#bulk_info_unavailable').removeAttr('disabled');
 });

export const inCart = (id,item_type) => {
	
	var index       =   (item_type+'_'+id);
	var cart        =   localStorage.getItem("mycart") != null ? JSON.parse(localStorage.getItem("mycart")) : {};

	if(cart[index])
	{
		return true;
	}
	return false;
}

export const ImageExist = (t) => {
    var e = new XMLHttpRequest();
    return e.open("HEAD", t, !1), e.send(), 404 != e.status && 403 != e.status;
}
export const GetMonthName = (t) => {
    return ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"][t - 1];
}

export const GetFullMonthName = (t) => {
    return ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"][t - 1];
}

export const tConvert = (time) => {
     // Check correct time format and split into components
     time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [
        time,
    ];

    if (time.length > 1) {
        // If time format correct
        time = time.slice(1); // Remove full string match value
        time[5] = +time[0] < 12 ? " AM" : " PM"; // Set AM/PM
        time[0] = +time[0] % 12 || 12; // Adjust hours
    }
    return time.join(""); // return adjusted time or original string
}

export const convertTZ = (date, tzString) => {
    return new Date(
        (typeof date === "string" ? new Date(date) : date).toLocaleString("en-US", {
            timeZone: tzString,
        })
    );
}

export const changeTimezone = (datetime, timezone) => {
    let date = new Date(datetime);
    // console.log("Given IST datetime: " + date);

    let usaTime = date.toLocaleString("en-US", {
        timeZone: timezone,
    });
    return usaTime;
}

export const stringToDate = (s) => {
    var dateParts = s.split(" ")[0].split("-");
    var timeParts = s.split(" ")[1].split(":");
    var d = new Date(dateParts[0], --dateParts[1], dateParts[2]);
    d.setHours(timeParts[0], timeParts[1], timeParts[2]);
    return d;
}

export const getDateFormat = () => {
    var dateFormatClient = "dd-mm-yyyy";
    if (typeof window.dateFormatServer !== "undefined") {
        dateFormatClient = window.dateFormatServer.key.toLowerCase();
    }
    return dateFormatClient;
}


export const getCountries = (fillFormOptions = false) => {
    fetch(window.__siteUrl+'/mykademy/api/v1/countries', {
        method	: 'GET',
        headers	: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
    .then((res)=>res.json())
    .then((result)=>{
        __getCountries                  =   result.data;
        
        if(fillFormOptions)
        {
            var countriesOptions        =   '<option value="">Select a country</option>';

            __getCountries.map((item, i) => {
                countriesOptions+= `<option value=${item.country_name}>${item.country_name}</option>`;
            });

            var countrySelection        =   $('#country');
            if(countrySelection != 'undefined')
            {
                countrySelection.html(countriesOptions);
            }
        }

        return __getCountries;
    }); 
}

export const convertDateFormat = (dateFormat, dateString = "", options = 1) => {
    var finalDate = new Array();
    var outputDate = "";
    if (
        typeof dateFormat !== "undefined" &&
        dateString != "" &&
        dateString != null &&
        dateString != undefined
    ) {
        switch (options) {
            case 1:
                var dateStringCluster = dateString.split("-");
                var newDateStringCluster = new Array(
                    dateStringCluster[2],
                    dateStringCluster[1],
                    dateStringCluster[0]
                );
                var newDate = newDateStringCluster.join();
                break;
            case 2:
                var newDate = dateString;
                break;
            case 3:
                var dateStringCluster = dateString.split("/");
                var newDateStringCluster = new Array(
                    dateStringCluster[2],
                    dateStringCluster[1],
                    dateStringCluster[0]
                );
                var newDate = newDateStringCluster.join();
                break;
                default:
        }
        var newDateString = new Date(newDate);
        var dateFormatCluster = dateFormat.split("-");
        dateFormatCluster.map((clusterValue) => {
            switch (clusterValue) {
                case "dd":
                    var initial = newDateString.getDate() < 10 ? "0" : "";

                    finalDate.push(initial + newDateString.getDate());
                    break;
                case "mm":
                    var initial = newDateString.getMonth() + 1 < 10 ? "0" : "";
                    finalDate.push(initial + parseInt(newDateString.getMonth() + 1));
                    break;
                case "yyyy":
                    finalDate.push(newDateString.getFullYear());
                    break;
                case "yy":
                    finalDate.push(newDateString.getFullYear().toString().substr(-2));
                    break;
            }
        });
        outputDate = finalDate.join("-");
    } else {
        var newDateString = new Date();
        finalDate = [
            newDateString.getDate(),
            newDateString.getMonth() + 1,
            newDateString.getFullYear(),
        ];
        outputDate = finalDate.join("-");
    }

    return outputDate;
}


$(document).ready(function() {
    
});


export const bulkLearnerFormLabel = () =>
{
    $("#bulk_learner_enroll :input").each(function(){
        var input = $(this);
        if($('#'+input.attr('id')).val() != '' && $('#'+input.attr('id')).val() != 0)
        {
            $(this).parent().find('label').addClass('active');
        }else{
            $(this).parent().find('label').removeClass('active');
        }
    });   
}



export const redirectUserExplore = () => {
    window.location.href = window.siteUrl+'course/listing';
}

export const loadTimeZones = () => {
    // console.log('window.__timeZones');
    // console.log(window.__timeZones);
    if(window.__timeZones.length > 0){
        var $timezoneList = $("#select_time_zone");
        $timezoneList.html('');
        $.each(window.__timeZones, function(index, timezone) {
            $timezoneList.append(
                $("<option></option>").text(timezone.name).val(timezone.value).prop('selected', timezone.value.indexOf(window.__configuredTimeZone) !== -1)
            );
        });
        applyTimeZoneFilter(); 
    }
}
 

export const renderSearchBlockOnCreate = (containterId) => {
    $('#'+containterId).html(renderSearchBlock());

}
 function renderSearchBlock()
 {
     
         var categoryHtml              = "";
         var n                         = 0;
         var searchBlockHtml           = '';

         $.ajax({
             url: __site_url+"api/course/homePageBannerCategories",
             type: "post",
             async:false,
             
             success: function (result) {
                 var jsonObj     = JSON.parse(result); 
                     var categories     = jsonObj.categories; 
                     if(Object.keys(categories).length > 0 ) { 
                         $.each(categories,function(courseKey,category){ 
                             n = n+1;
                             categoryHtml     += '<li><a href="'+__site_url+'course/listing?&amp;categoryids='+category.id+'" class="highlight-text-link toplink-color">'+category.ct_name+'</a></li>';
                             if(n >4){ 
                                 return false;
                             } 
                         }); 
                     } 
                         searchBlockHtml+= '<div class="search-and-higlights-waraper" >';
                         searchBlockHtml+= '   <span class="search-bar-in-banner-wraper custom-dashboard-searchbar">';
                         searchBlockHtml+= '      <span class="olp-banner-search"><input type="search" class="olp-inputBox" autocomplete="off" placeholder="Find a course" onfocus="this.placeholder=""" id="searchid" onblur="this.placeholder=\""Find a course"\"> </span>';
                         searchBlockHtml+= '      <span class="olp-search-btn">';
                         searchBlockHtml+= '         <a class="olp-link-btn" id="searchbtn">';
                        //  searchBlockHtml+= '            <button class="talkback-accessibility">Search</button> ';
                         searchBlockHtml+= '            <svg version="1.1" x="0px" y="0px" viewBox="0 0 37.9 37.9" enable-background="new 0 0 37.9 37.9" xml:space="preserve">';
                         searchBlockHtml+= '               <g>';
                         searchBlockHtml+= '                  <path fill="#666" d="M24.3,26.9v-1.7l-1.1-1.1l-0.4,0.3c-2.5,2.1-5.6,3.3-8.8,3.3c-7.5,0-13.6-6.1-13.6-13.6S6.6,0.5,14.1,0.5 s13.6,6.1,13.6,13.6c0,3.2-1.2,6.4-3.3,8.8l-0.3,0.4l1.1,1.1h1.7l10.3,10.3l-2.5,2.5L24.3,26.9z M14.1,3.8C8.4,3.8,3.8,8.4,3.8,14.1s4.6,10.2,10.3,10.2c5.7,0,10.2-4.6,10.2-10.2S19.7,3.8,14.1,3.8z"></path>';
                         searchBlockHtml+= '                  <path fill="#FFFFFF" d="M14.1,1c7.2,0,13.1,5.9,13.1,13.1c0,3.1-1.1,6.1-3.2,8.5l-0.6,0.7l0.7,0.7l0.6,0.6l0.3,0.3h0.4h1.3l9.8,9.8l-1.8,1.8l-9.8-9.8v-1.3V25l-0.3-0.3L24,24.1l-0.7-0.7L22.6,24c-2.4,2-5.4,3.2-8.5,3.2C6.9,27.2,1,21.3,1,14.1C1,6.9,6.9,1,14.1,1 M14.1,24.8c5.9,0,10.8-4.8,10.8-10.8S20,3.3,14.1,3.3S3.3,8.2,3.3,14.1S8.2,24.8,14.1,24.8 M14.1,0C6.3,0,0,6.3,0,14.1c0,7.8,6.3,14.1,14.1,14.1c3.5,0,6.7-1.3,9.2-3.4l0.6,0.6v1.7l10.8,10.8l3.2-3.2L27.1,23.8h-1.7l-0.6-0.6c2.1-2.5,3.4-5.7,3.4-9.2 C28.2,6.3,21.9,0,14.1,0L14.1,0z M14.1,23.8c-5.4,0-9.8-4.4-9.8-9.8s4.4-9.8,9.8-9.8c5.4,0,9.8,4.4,9.8,9.8S19.5,23.8,14.1,23.8 L14.1,23.8z"></path>';
                         searchBlockHtml+= '               </g>';
                         searchBlockHtml+= '            </svg>';
                         searchBlockHtml+= '         </a>';
                         searchBlockHtml+= '      </span>';
                         searchBlockHtml+= '   </span>';
                         searchBlockHtml+= '   <span class="highlight-in-banner-wraper  conveythis-no-translate skiptranslate notranslate">';
                         searchBlockHtml+= '      <ul class="highlight-text banner-search-block-color top-header-wrapper">';
                         searchBlockHtml+=           categoryHtml;
                         searchBlockHtml+= '      </ul>';
                         searchBlockHtml+= '   </span>';
                         searchBlockHtml+= '</div>';
 
             },
             error: function () {
                 alert('Failurecrx');
             }
         });
         return searchBlockHtml;
 }

 export const addToCart = (item = false ,id, item_type, learners = {}, other = {}) => {
    if(localStorage.getItem("mycart") == "[]") localStorage.setItem("mycart","{}");
    var cart        =   localStorage.getItem("mycart") != null ? JSON.parse(localStorage.getItem("mycart")) : {};
	var oncart      =   true;
	var index       =   (item_type+'_'+id);

	if(!cart[index]){
		cart[index] =   {
                            "id":id,
                            "type":item_type,
                            "learners" : learners,
							"metadata": {},
                            "other":other,
                        };
        var cart_temp   =   cart[index];
        var cart_count  =   Object.keys(cart).length;
            cart        =   JSON.stringify(cart);
        localStorage.setItem("mycart", cart);
        localStorage.setItem("mycart_count", cart_count);

        if(window.isLoggedin != '')
        {
            var data = {};
            data[index] = cart_temp;
            postFormDataAsJson(window.site_url+'cart_react/add_to_cart',data);
        }  
        if (item) {
            $(item).text("Go to Cart");
            $('.notitication-alert').text(cart_count);     
        }
	} else {
        goToCart();
    }
}

export const goToCart = () => {
	if(window.isLoggedin == '' && window.isGuestEnabled != '1')
	{
        let url         = window.site_url + 'cart_react';
        window.location = window.site_url + 'login'+'?redirect_url='+encodeURIComponent(url);
	}
	else{
		window.location = window.__site_url+'cart_react';
	}
}

export const buyNow = (item = false,id,item_type,learners=[],other={}) => {
    let ppsEnabled      = 0;
    let bookingStatus   = '1';
    let slug            = '';
    var index           =   (item_type+'_'+id);
    if((typeof(window.loggedUserid) != undefined && window.loggedUserid != '') || window.isGuestEnabled == '1'){
			window.location = window.site_url+'cart_react?item='+index;
    } else {
        let url = window.site_url+'cart_react?item='+index;
        window.location = window.__site_url + 'login'+'?redirect_url='+encodeURIComponent(url);
        
        set_cookies(window.__memcacheKey+'redirect_url', url, (300));
    }
}

export const postFormDataAsJson = (apiCall, formData ) => {
    console.groupCollapsed('postFormDataAsJson');
    //  console.log(formData);
    console.groupEnd();
    
        const formDataJsonString = JSON.stringify(formData);
    
        const fetchOptions = {
            
            method: "POST",
        
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
        
            body: formDataJsonString,
        };
    
        const response =  fetch(apiCall, fetchOptions);
        // if (!response.ok) {
        // 	const errorMessage =  response.text();
        // 	throw new Error(errorMessage);
        // }
    
        // return response.json();
}
 